export type TipoContrato =
  | 'monotributo'
  | 'responsable_inscripto'
  | 'persona_juridica'
  | 'sucesion_indivisa'

export function determinarTipoContrato(
  tipoPersona: string | null | undefined,
  condicionIva: string | null | undefined,
): TipoContrato {
  if (tipoPersona) {
    const tp = tipoPersona.toLowerCase()
    if (tp === 'sucesion_indivisa' || tp.includes('sucesion')) return 'sucesion_indivisa'
    if (tp === 'juridica' || tp === 'persona_juridica') return 'persona_juridica'
  }

  if (condicionIva) {
    const condicion = condicionIva.toLowerCase()
    if (condicion.includes('monotribut')) return 'monotributo'
    if (
      condicion.includes('responsable') ||
      condicion.includes('inscripto') ||
      condicion.includes('inscript')
    ) {
      return 'responsable_inscripto'
    }
  }

  return 'monotributo'
}

const REGIMEN_IIBB_LABELS: Record<string, string> = {
  local: 'Local (jurisdicción única)',
  convenio_multilateral: 'Convenio Multilateral',
  simplificado: 'Régimen Simplificado',
  no_gravado: 'No gravado',
}

export function regimenIibbLabel(regimen: string | null | undefined): string | null {
  if (!regimen) return null
  return REGIMEN_IIBB_LABELS[regimen] ?? regimen
}
